import React from "react";
import { Helmet } from "react-helmet";

function RefundPolicy() {
  return (
    <>
      <Helmet>
        <title>Refund Policy » ClubHosty</title>
        <link rel="canonical" href="https://www.clubhosty.com/refund-policy" />
      </Helmet>
      <main id="main">
        <section className="breadcrumbs">
          <div className="container">
            <div>
              <h2>Refund Policy</h2>
              <center>
                {" "}
                <p>Your money ! Your Decision</p>
              </center>
            </div>
          </div>
        </section>

        {/* ======= Services Section =======  */}
        <section id="services" className="services">
          <div className="container">
            <div className="row">
              <div className="col-md-12 section-heading">
                <h3>Refund Policy Of ClubHosty</h3>
                <p>
                  1. If paying via credit card, debit card, net banking, PayPal
                  the account will be set up immediately once the payment is
                  confirmed.{" "}
                </p>
                <p>
                  2. ClubHosty will only issue the refunds in ClubHosty account
                  funds with no time limit unless noted otherwise.
                </p>
                <p>
                  3. Refund is not applicable on the following services: Hosting renewal, domain
                  registration/transfer/renewal, Control Panel licenses,
                  LiteSpeed, Softaculous, Cloud VPS/Cloud hosting, Dedicated Server, Paid
                  Support, SSL Certificates, Sitelock, SpamExperts, WHMCS,
                  Windows OS, SQL, G Suite, Office 365 and any other paid
                  licenses or add-ons.
                </p>
                <p>
                  4. The modifications done in pricing pattern or policy by the
                  software license company will take effect immediately on
                  ClubHosty clients.
                </p>
                <p>
                  5. A 7-day money-back-guarantee is provided on Shared hosting,
                  Reseller hosting and cPanel hosting only.
                </p>
                <p>
                  6. No refund will be made if your Service(s) are suspended or
                  terminated for cause.
                </p>
                <p>
                  7. Each hosting platform has inherent limitations that customers should understand before purchase. These technical limitations do not constitute grounds for refunds as they are standard industry practices and documented features of the respective hosting types.
                </p>
                <p>
                  8. The refund will not cover any kind of taxes, setup fees,
                  refund processing fee, postal charges or any kind of payment
                  processing charges or bank fee(s). There will be no refunds
                  issued in case the web hosting account was involved in
                  violation of our terms of service or any kind of illegal or
                  system resources over-usages or after 7 days period or beyond
                  the coverage of our refund policy as noted here.
                </p>
                <p>
                  9. <strong>Free Domain Policy for Hosting Plans</strong>
                </p>
                <p>
                  The following hosting plans include 1 free domain for 1 year when purchased annually:
                </p>
                <p>
                  - Shared Hosting: DAElite plan<br/>
                  - cPanel Hosting: ClubElite plan<br/>
                  - Cloud Hosting: PREMIUM#2 and PREMIUM#3 plans
                </p>
                <p>
                  You may transfer your existing domain under this offer. The domain name will be free
                  for the first year and renewal charges will be applicable from
                  the second year.
                </p>
                <p>
                  10. You must add the domain name to your cart with the hosting
                  plan. Alternatively, you can claim your free domain within 7 days of hosting purchase by contacting our support team (to remain eligible for refund policy).
                </p>
                <p>
                  11. If the web hosting service includes a free domain name,
                  and you cancel the web hosting service, the domain charges
                  (standard rate as per website) would be deducted from the
                  refund amount. If the refund amount is less than the domain
                  name price, you will have to pay the difference or forfeit the
                  domain. The ownership of the domain will remain with ClubHosty
                  if you fail to pay the difference amount.
                </p>
                <p>
                  12. Domain Transfer and Refund Policy: Transfer fees are applicable if you wish to transfer
                  the free or promotional domain name to another provider. Without payment of transfer
                  fees, the domain will not be released. Domain transfers are restricted if invoices remain unpaid or within 60 days of recent payments to ensure billing integrity and prevent fraudulent transfer attempts during pending payment periods.
                </p>
                <p>
                  13. The refund request placed after 7 days will not be
                  processed and you will not be eligible for any refund.
                </p>
                <p>
                  14. The cancellation request should be sent through the client
                  area.
                </p>
                <p>
                  15. After sending the cancellation request, it would take 5-7
                  business working days to complete the refund process.
                </p>
                <p>
                  16. Refund will only be applicable in case we are unable to
                  resolve your issue or if we have failed to provide support.
                </p>
                <p>
                  17. <strong>Anti-Fraud and Multiple Account Policy:</strong> Only first-time accounts are eligible for a refund. 
                  Creating multiple accounts to claim promotional discounts or repeatedly accessing new customer benefits is 
                  strictly prohibited and considered fraudulent activity. You will <strong>NOT</strong> be eligible for a refund if:
                </p>
                <ul>
                  <li>You've had an account with us before, canceled it, and signed up again</li>
                  <li>You have opened a second (or multiple) account(s) with us using different details</li>
                  <li>You used a coupon code or discount intended for first-time customers on a non-first-time purchase</li>
                  <li>You created an account to abuse promotional offers or new customer discounts</li>
                  <li>Our fraud detection systems identify your account as being linked to other existing or previous accounts</li>
                  <li>You provided false, misleading, or fraudulent information during registration</li>
                </ul>
                <p>
                  Any violations of this Agreement, our Terms and Conditions, or our Anti-Fraud and Discount Abuse Policy 
                  will immediately waive your rights under the refund policy. Orders identified as fraudulent will be 
                  rejected without refund, and all associated accounts may be permanently suspended or terminated.
                </p>
                <p>
                  18. Reseller Hosting Specific Terms: Reseller hosting plans are eligible for 7-day money-back guarantee. Any WHMCS licenses included with reseller plans are non-refundable and will be deducted from refund amount if applicable.
                </p>
              </div>
              <div id="nav-id-1" className="pt-5 section-heading">
                <h5>
                  <i className="fa fa-angle-double-right"></i> What if I want my
                  Money After 7 Days?
                </h5>
                <p>
                  Sorry but If the refund is requested after the 7 days period
                  of your service no refund will be initiated.
                </p>
              </div>
              <div id="nav-id-2" className="pt-5 section-heading">
                <h5>
                  <i className="fa fa-angle-double-right"></i> Modifications
                </h5>
                <p>
                  ClubHosty reserves the right to revise, amend, or modify this
                  AUP, our TOS (Terms of Service) and our other policies and
                  agreements at any time and in any manner.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* End Services Section  */}
      </main>
      {/* End #main */}
    </>
  );
}

export default RefundPolicy;
